import { Component, Input, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";

@Component({
	selector: "caass-ms-visitee-staff-table",
	templateUrl: "./ms-visitee-staff-table.component.html",
	styleUrls: ["./ms-visitee-staff-table.component.css"],
})
export class MsVisiteeStaffTableComponent implements OnInit {
	constructor() {}

	ngOnInit(): void {
		this.UpdateFilters();
	}

	ngOnChanges() {
		this.UpdateFilters();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	@Input() loading: boolean = false;
	pagerows: any = 5;
	pagefirst: any = 0;
	errorMessage: any = "";

	SelectedPerson: any;
	@Input() lstPerson: any = [];

	//Filter lists
	lstVisiteeEnabledDesc: any = [];
	lstNotifyByEmailDesc: any = [];

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onPersonVisiteeEnabledChange(Person, val) {
		Person.VisiteeEnabled = val;

		if (val == true) {
			Person.VisiteeEnabledDesc = "Yes";
			Person.NotifyByEmail = true; //Default to true
		} else {
			Person.VisiteeEnabledDesc = "No";
		}
	}

	onPersonNotifyByEmailChange(Person, val) {
		Person.NotifyByEmail = val;

		if (val == true) {
			Person.NotifyByEmailDesc = "Yes";
		} else {
			Person.NotifyByEmailDesc = "No";
		}
	}

	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedPerson = val.data;
	}
	onRowUnselect(val) {
		this.SelectedPerson = null;
	}
	////////////////////////////////////////////

	////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////

	UpdateFilters() {
		this.lstVisiteeEnabledDesc = Array.from(new Set(this.lstPerson.map((item: any) => item.VisiteeEnabledDesc))).sort();
		this.lstNotifyByEmailDesc = Array.from(new Set(this.lstPerson.map((item: any) => item.NotifyByEmailDesc))).sort();
	}

	////////////////////////////////////////////
}
